import React from 'react';
import About from '../../components/PublicSite/About';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

// Route lama merender about.md lewat komponen Page (boilerplate starter kit).
// File .md dibiarkan di tempatnya — tidak lagi diimpor, aman dihapus kapan saja.
async function action() {
  await loadSiteCopy();
  return {
    title: 'About Bas Recovery — 24/7 Roadside Assistance in the UAE',
    description: 'Bas Recovery connects UAE drivers with verified recovery trucks in about 25 minutes. Founded in 2024, 54 verified partners, 12,400 jobs completed across all seven emirates.',
    component: (
      <HeadLessLayout>
        <About />
      </HeadLessLayout>
    ),
  };
}

export default action;
